var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M30.943 20.685 29.71 21.92l-2.526-2.532 1.232-1.236a.677.677 0 0 1 .949 0l1.577 1.582a.68.68 0 0 1 0 .95Zm-11.95 6.905 7.465-7.486 2.526 2.533-7.454 7.498h-2.538zm0-6.102c-5.446 0-9.856 2.21-9.856 4.94V28.9h7.392v-2.334l4.927-4.941a21 21 0 0 0-2.463-.136Zm0-12.353c-1.307 0-2.56.52-3.485 1.447a4.95 4.95 0 0 0 0 6.988 4.92 4.92 0 0 0 6.97 0 4.95 4.95 0 0 0 0-6.988 4.92 4.92 0 0 0-3.486-1.447Z"
})));
export default SvgAccountEdit;